import {
    FETCH_LOI_LIST_REQUEST,
    FETCH_LOI_LIST_SUCCESS,
    FETCH_LOI_LIST_FAILURE,

    CREATE_LOI_REQUEST,
    CREATE_LOI_SUCCESS,
    CREATE_LOI_FAILURE,

    UPDATE_LOI_REQUEST,
    UPDATE_LOI_SUCCESS,
    UPDATE_LOI_FAILURE
} from './types';


/**
 *
 * @param {Object} [params]
 * @returns
 */
 export const fetchLoiListRequest = (params) => ({
    type: FETCH_LOI_LIST_REQUEST,
    payload: params
});

/**
 *
 * @param {BrokerFirmListState} data
 * @returns
 */
export const fetchLoiListSuccess = (data) => ({
    type: FETCH_LOI_LIST_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function fetchLoiListFailure(error) {
    return {
        type: FETCH_LOI_LIST_FAILURE,
        error
    };
}




/**
 *
 * @param {Object} [params]
 * @returns
 */
 export const createLoiRequest = (params) => ({
    type: CREATE_LOI_REQUEST,
    payload: params
});

export const createLoiSuccess = (data) => ({
    type: CREATE_LOI_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function createLoiFailure(error) {
    return {
        type: CREATE_LOI_FAILURE,
        error
    };
}



/**
 *
 * @param {BrokerFirm} params
 * @returns
 */
 export const updateLoiRequest = (params) => ({
    type: UPDATE_LOI_REQUEST,
    payload: params
});

export const updateLoiSuccess = (data) => ({
    type: UPDATE_LOI_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function updateLoiFailure(error) {
    return {
        type: UPDATE_LOI_FAILURE,
        error
    };
}
